import { Injectable, Inject } from '@angular/core';
import { Http, RequestOptionsArgs, Headers, Response, ResponseContentType } from '@angular/http';
import { EnvironmentProvider } from './browser-providers';
import { Environment } from '../../environments/enviroment.model';
import { Cliente } from '../cliente/cliente.model';
import { Observable } from 'rxjs/Observable';
import { Producto } from '../productos/producto.model';
import { Pedido } from '../pedido/pedido.model';
import { ImagenBanner } from '../banner/banner-imagen-upload/imagen-banner.model';

@Injectable()
export class ClienteService {

  private tokenId = 'jwtToken';
  protected backendUrl: string;
  constructor(
    protected http: Http,
    @Inject(EnvironmentProvider) env: Environment,
  ) {
    this.backendUrl = env.endpoints.apiBack;
  }

  getHashForUpload() {
    return this.http.get(this.buildUrl(Cliente.path + 'documentacion/hash'),
    this.buildRequestOptions()).toPromise();
  }

  getImagenById(id: number): Observable<Blob> {
    return this.http.get(this.buildUrl(Producto.newPath + 'renders-productos/' + id),
    this.buildRequestOptions({ responseType: ResponseContentType.Blob }))
    .map((res: Response) => res.blob());
  }

  getLogoById(id: number): Observable<Blob> {
    return this.http.get(this.buildUrl(Cliente.path + 'logo/' + id),
    this.buildRequestOptions({ responseType: ResponseContentType.Blob }))
    .map((res: Response) => res.blob());
  }

  getPrevisualizacionById(id: number): Observable<Blob> {
    return this.http.get(this.buildUrl(Pedido.path + 'imagen/' + id),
    this.buildRequestOptions({ responseType: ResponseContentType.Blob }))
    .map((res: Response) => res.blob());
  }

  getPrevisualizacionComprobante(comprobante: string): Observable<Blob> {
    return this.http.get(this.buildUrl(Pedido.path + 'imagen-comprobante/' + comprobante),
    this.buildRequestOptions({ responseType: ResponseContentType.Blob }))
    .map((res: Response) => res.blob());
  }

    getDocCompletaById(id: number): Observable<Blob> {
    return this.http.get(this.buildUrl(Cliente.path + 'documentacion-completa/' + id),
    this.buildRequestOptions({ responseType: ResponseContentType.Blob }))
    .map((res: Response) => res.blob());
  }

  getImagenBannerById(id: number): Observable<Blob> {
    return this.http.get(this.buildUrl('/banner/imagen/' + id),
    this.buildRequestOptions({ responseType: ResponseContentType.Blob }))
    .map((res: Response) => res.blob());
  }

  public buildUrl(path: string) {
    return this.backendUrl + encodeURI(path);
  }

  private buildRequestOptions(options: RequestOptionsArgs = {}) {
    options.headers = options.headers || new Headers();
    options.headers.append('Content-Type', 'application/ld+json');
    const token = this.token;
    if (token) {
      options.headers.append('Authorization', 'Bearer ' + token);
    }
    return options;
  }

  get token() {
    return localStorage.getItem(this.tokenId);
  }

  putComprobanteAprobado(pedidoId: number){
      return this.http.put(
        this.buildUrl(Pedido.path + 'comprobante-transferencia/aprobado/' + pedidoId),
        null,
        this.buildRequestOptions()
      ).toPromise();
  }

  putComprobanteRechazado(pedidoId: number){
    return this.http.put(
      this.buildUrl(Pedido.path + 'comprobante-transferencia/rechazado/' + pedidoId),
      null,
      this.buildRequestOptions()
    ).toPromise();
}
}



// WEBPACK FOOTER //
// ./src/app/core/cliente.service.ts